// extracted by mini-css-extract-plugin
module.exports = {"container":"_2txpVolr0MI7SC9GwOJeyu","content":"_2-dovRZ1RjO8iiiPzB6mRB textColor","last":"_1sNOhqYnFIempEzX4Id7_E","right":"_1TBd2BEekI5LjR9JiBcX2V"};